export default __webpack_public_path__ + "static/media/Group 3205@2x.1eb871a9.png";